import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CompanyAPI, CompanyProfileInput } from "../lib/api/company";

export function useCompanyProfile(companyId?: string) {
    const queryClient = useQueryClient();
    const queryKey = ["company_profile", companyId];

    const { data, isLoading: loading, error } = useQuery({
        queryKey,
        queryFn: () => CompanyAPI.getProfile(companyId as string),
        enabled: !!companyId,
        staleTime: 5 * 60 * 1000,
    });

    const { mutateAsync: updateProfile, isPending: saving } = useMutation({
        mutationFn: (input: CompanyProfileInput) => CompanyAPI.updateProfile(input),
        onSuccess: (updated) => {
            queryClient.setQueryData(queryKey, updated);
        },
    });

    return { data, loading, error, updateProfile, saving };
}
